import { useEffect, useRef, useState } from 'react'

import { GaugeComponent, GaugeComponentProps } from 'react-gauge-component'
import { useTranslation } from 'react-i18next'

import { getGaugeOptionsAndDataV2 } from './dataConverter'
import { ChartData } from '@/Atomic/Organisms/Charts/acBar/dataConverter'

import '../ChartError.scss'
import '../Charts.scss'
import './GaugeChart.scss'

interface Param {
  salesData: ChartData | undefined
}

export function GaugeChart({ salesData = undefined }: Param) {
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    const checkExpanded = () => {
      const wrapper = containerRef.current?.closest('.chartWrapper')
      setIsExpanded(wrapper?.classList.contains('chartExpanded') ?? false)
    }

    checkExpanded()

    // Listen for class changes
    const observer = new MutationObserver(checkExpanded)
    const wrapper = containerRef.current?.closest('.chartWrapper')
    if (wrapper) {
      observer.observe(wrapper, {
        attributes: true,
        attributeFilter: ['class'],
      })
    }

    return () => observer.disconnect()
  }, [])

  if (!salesData) {
    return <div></div>
  }

  let gaugeConfig: GaugeComponentProps

  try {
    gaugeConfig = getGaugeOptionsAndDataV2(salesData) as GaugeComponentProps
  } catch (error) {
    console.error(
      'Error processing gauge chart data:',
      error instanceof Error ? error.message : 'Unknown error',
    )
    return (
      <div className="chart-error">
        {t('components.dashboard.chart.unableToRender')}
      </div>
    )
  }

  return (
    <div ref={containerRef} className="gauge-chart-container">
      <div className={isExpanded ? 'gauge-expanded' : ''}>
        <GaugeComponent
          key={isExpanded ? 'expanded' : 'normal'}
          {...gaugeConfig}
        />
      </div>
      <div className="gauge-chart-footer"></div>
    </div>
  )
}
